export const WALLET_ADDRESS_VALIDATORS: Record<string, RegExp> = {
  BTC: /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,62}$/,
  EVM: /^0x[0-9a-fA-F]{40}$/,
  BSC: /^0x[0-9a-fA-F]{40}$/,
  TRON: /^T[1-9A-HJ-NP-Za-km-z]{33}$/,
};

export const validateWalletAddress = (
  network: string,
  address: string,
): string => {
  if (!address) return "";
  const regex = WALLET_ADDRESS_VALIDATORS[network];
  if (!regex) return "";
  return regex.test(address) ? "" : `Invalid ${network} address format`;
};
